export default "__VITE_ASSET__CCP$P9pS__"